import axios from "axios";
import authHeader from "@/Api/AuthHeader";

const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getMyDatas() {
      return await axios.get(URL_API + "student-profile", {
        headers: authHeader(),
      });
    },
    async getTotalExtratNotPayed() {
      return await axios.get(URL_API + "getTotalExtratNotPayed", {
        headers: authHeader(),
      });
    },
    async getStudentAssementResult(subject_id, year, student_id = null) {
      return await new Promise((resolve, reject) => {
        axios
          .get(
            URL_API +
              `getStudentAssementResult?subject_id=${subject_id}&student_id=${student_id}&year=${year}`,
            {
              headers: authHeader(),
            }
          )
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    async getTurmas() {
      try {
        const resp = await axios.get(URL_API + "teacher-profile", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getSubjects() {
      try {
        const resp = await axios.get(URL_API + "teacher-profile", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getStudentByClassMates(classmate_id) {
      try {
        const resp = await axios.get(
          URL_API + "list-students-by-turma/" + classmate_id,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getLectures(subject_id) {
      try {
        const resp = await axios.get(URL_API + "get-lectures/" + subject_id, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async submitData(testData, subject_id) {
      try {
        const resp = await axios.post(
          URL_API + "createFormula",
          {
            testData,
            subeject_id: subject_id,
          },
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getAllFormulas() {
      try {
        const resp = await axios.get(URL_API + "getAllFormulas", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },
    async getFormulaByClass(classmate_id) {
      try {
        const response = await axios.get(
          URL_API + `get-formula-by-classmate/${classmate_id}`,
          { headers: authHeader() }
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },

    async DeleteDataTest(id) {
      try {
        const resp = await axios.delete(URL_API + "DeleteFormula/" + id, {
          headers: authHeader(),
        });
      } catch (error) {
        return error;
      }
    },
    async updateFormula(payload, id) {
      try {
        const resp = await axios.put(
          URL_API + "updateFormula/" + id,
          {
            classmate_id: payload.classmate_id,
            assessment_type: payload.assessment_type,
            percentage: payload.percentage,
          },
          { headers: authHeader() }
        );

        return resp;
      } catch (error) {
        return error;
      }
    },
    async assessmentResults(data) {
      try {
        const resp = await axios.post(
          URL_API + "give-result-to-many",
          { data },
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {}
    },
    async getAllYearSubscribed() {
      return await axios.get(URL_API + "allsubscribedYear", {
        headers: authHeader(),
      });
    },

    async getpaymentTransation(type) {
      return await axios.get(URL_API + "getAllPaymentTransationsByType", {
        headers: authHeader(),
      });
    },

    async getAllpaymentTransation() {
      return await axios.get(URL_API + "getAllPaymentTransations", {
        headers: authHeader(),
      });
    },
    async getAllPaymentTransationsByType(type) {
      return await axios.get(
        URL_API + `getAllPaymentTransationsByType?type=${type}`,
        {
          headers: authHeader(),
        }
      );
    },
    async StudentAssessment(year) {
      return await axios.get(
        URL_API + `StudentAssessment?academic_year=${year}`,
        {
          headers: authHeader(),
        }
      );
    },

    async totalCommunication() {
      return axios.get(URL_API + "totalCommunication", {
        headers: authHeader(),
      });
    },
    async communications() {
      return axios.get(URL_API + "communications", {
        headers: authHeader(),
      });
    },
    async inscriptions(student_id) {
      return axios.get(URL_API + `inscriptionsRenew?student_id=${student_id}`, {
        headers: authHeader(),
      });
    },

    async cancelInscription(id, status) {
      return axios.get(
        URL_API +
          `cancelInscriptionRenew?inscriptionRenewId=${id}&status=${status}`,
        {
          headers: authHeader(),
        }
      );
    },

    async makePayment(data) {
      return axios.post(
        URL_API + `make-payment`,
        {
          phone: data.contact,
          amount: data.amount_real,
          gateway: "mpesa",
        },
        {
          headers: authHeader(),
        }
      );
    },
  },
};
